import type {
  WSelectionControlModelValue,
  WSelectionControlValue,
  WSelectionControlVariant,
} from './WSelectionControl.types'

export function isSelectionControlSelected(
  modelValue: WSelectionControlModelValue,
  value?: WSelectionControlValue,
  selected?: boolean
) {
  if (selected !== undefined) {
    return selected
  }

  if (Array.isArray(modelValue)) {
    return value !== undefined && modelValue.includes(value)
  }

  if (value !== undefined) {
    return modelValue === value
  }

  return Boolean(modelValue)
}

export function getNextSelectionControlModel(
  variant: WSelectionControlVariant,
  modelValue: WSelectionControlModelValue,
  value?: WSelectionControlValue,
  selected?: boolean
): WSelectionControlModelValue {
  const isSelected = isSelectionControlSelected(modelValue, value, selected)

  if (variant === 'radio') {
    return value ?? true
  }

  if (variant === 'text') {
    return value ?? !isSelected
  }

  if (Array.isArray(modelValue)) {
    if (value === undefined) {
      return modelValue
    }

    return isSelected
      ? modelValue.filter((currentValue) => currentValue !== value)
      : [...modelValue, value]
  }

  if (value !== undefined) {
    return isSelected ? null : value
  }

  return !isSelected
}
